var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-auto"},[(_vm.pages)?_c('b-pagination-nav',{attrs:{"link-gen":_vm.linkGen,"number-of-pages":_vm.pages,"align":"fill","use-router":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }